// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectFormStock_content__oFH6Z","submitContent":"ProjectFormStock_submitContent__9oTYD","submitButton":"ProjectFormStock_submitButton___ejbJ"};